import { PromoConditionTypeConfig } from '~/services/PromoService';

type ConditionWithType = {
  condition_type?: string | null;
};

type ConditionTypeConfigWithDependentFields = PromoConditionTypeConfig & {
  dependentItemFields?: Array<string> | null;
  dependent_item_fields?: Array<string> | null;
};

/**
 * Returns request/log item field keys that should be visible by default based on selected conditions.
 * Supports both `dependentItemFields` and `dependent_item_fields` until all producers are aligned.
 */
export function getDependentItemFieldsFromSelectedConditions(
  conditions: Array<ConditionWithType> | null | undefined,
  conditionTypeConfigs: Array<ConditionTypeConfigWithDependentFields> | null | undefined,
): Array<string> {
  if (!conditions?.length || !conditionTypeConfigs?.length) {
    return [];
  }

  const selectedConditionTypes = new Set(
    conditions.map((condition) => condition?.condition_type?.trim()).filter((value): value is string => Boolean(value)),
  );

  if (selectedConditionTypes.size === 0) {
    return [];
  }

  const out = new Set<string>();

  conditionTypeConfigs.forEach((config) => {
    if (!config) {
      return;
    }
    const key = String(config.key ?? '').trim();
    if (!key || !selectedConditionTypes.has(key)) {
      return;
    }
    const dependentFieldsSource = config.dependentItemFields ?? config.dependent_item_fields ?? [];
    const dependentFields = Array.isArray(dependentFieldsSource) ? dependentFieldsSource : [];
    dependentFields.forEach((field) => {
      const normalizedField = field?.trim();
      if (!normalizedField) {
        return;
      }
      out.add(normalizedField);
    });
  });

  return Array.from(out);
}
